import React from "react";
import { useSelector } from "react-redux";
import Table from "../../../components/table/coreUiTable/Table";
import {
  XLSX,
  dataForTables,
  getFormattedData,
  getScopedSlots,
  makeColHeadersUnique
} from "../utils/dataForTables";
import { useIncreasedTableWidth } from "../hooks/useIncreasedTableWidth";

export const ConversionTable = () => {
  useIncreasedTableWidth(".table-wrapper.conversion-table .table-responsive");
  const { data, colHeaders, columns } = useSelector(
    (state) => state.multiLocation.conversions.tableInfo
  );

  let formattedData = getFormattedData(data);
  let headers = makeColHeadersUnique(colHeaders);
  let scopedSlots = getScopedSlots(data, headers);

  return (
    <>
      <XLSX colHeaders={colHeaders} data={data} columns={columns} />
      <Table
        overrideColumnCallback={(header, index) => ({
          _style: header === "Location" ? { width: "125px" } : {},
          label: colHeaders[index]
        })}
        table={{ data: formattedData, colHeaders: headers }}
        scopedSlots={scopedSlots}
        {...dataForTables}
      />
    </>
  );
};
export default ConversionTable;
